export default __webpack_public_path__ + "static/media/down-range.99bf6fb1.svg";